import SectionHeading from "./SectionHeading";
import { trustStats } from "./data";

const trustPoints = [
  {
    icon: "ri-verified-badge-line",
    title: "唯一官方认证",
    desc: "全网络仅此一处正版认证入口，无任何镜像或授权分站。",
  },
  {
    icon: "ri-shield-keyhole-line",
    title: "标识公开可验",
    desc: "红色封签式认证角标样式公开，读者可随时对照本页图样核对。",
  },
  {
    icon: "ri-lock-2-line",
    title: "安全访问通道",
    desc: "正版入口接入加密访问链路，全程不引导下载任何第三方应用。",
  },
  {
    icon: "ri-service-line",
    title: "状态持续监测",
    desc: "入口可用性与异常挂载均设有监测，异常时会第一时间发布快讯。",
  },
];

export default function Trust() {
  return (
    <section id="trust" className="scroll-mt-24 bg-background-50">
      <div className="mx-auto max-w-6xl px-4 py-10 md:px-6 md:py-14">
        <div className="grid items-start gap-8 lg:grid-cols-12">
          {/* 认证封签视觉 */}
          <div className="lg:col-span-5">
            <div className="relative overflow-hidden rounded-lg bg-foreground-950 p-6 text-background-50 md:p-8">
              <div
                className="pointer-events-none absolute inset-0 opacity-[0.06]"
                style={{
                  backgroundImage:
                    "radial-gradient(circle at 20% 20%, #D49527 0, transparent 40%), radial-gradient(circle at 80% 70%, #D93B24 0, transparent 45%)",
                }}
              ></div>
              <p className="text-[11px] tracking-[0.24em] text-background-200 md:text-xs">OFFICIAL VERIFIED SEAL</p>
              <div className="mt-6 flex h-28 w-28 items-center justify-center rounded-full border-[3px] border-accent-400 bg-accent-500/10 md:h-32 md:w-32">
                <div className="flex flex-col items-center justify-center text-center">
                  <i className="ri-verified-badge-fill text-3xl text-accent-300 md:text-4xl"></i>
                  <span className="mt-1.5 font-display text-base font-bold text-background-50 md:text-lg">已认证</span>
                </div>
              </div>
              <p className="mt-6 font-display text-2xl font-bold leading-snug md:text-3xl">
                认准这枚红色封签
                <br />
                仅此一种官方认证形态
              </p>
              <p className="mt-3 max-w-sm text-xs leading-relaxed text-background-200 md:text-sm">
                无论页面如何更新，认证角标始终固定出现在首页右上角，颜色、图案与位置保持一致，不设任何变体。
              </p>
            </div>
          </div>

          {/* 信任要点 */}
          <div className="lg:col-span-7">
            <SectionHeading
              eyebrow="信任背书 · 认证说明"
              title="为什么值得相信这个入口"
              desc="本站唯一的使命，是帮你避开仿冒、快速找到真正的吃瓜官网官方地址。以下承诺公开、透明、随时可验证。"
            />
            <div className="mt-6 grid gap-3 sm:grid-cols-2">
              {trustPoints.map((point) => (
                <div
                  key={point.title}
                  className="flex gap-3 rounded-lg border border-background-200 bg-background-100/50 p-4"
                >
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-100 text-lg text-primary-600">
                    <i className={point.icon}></i>
                  </span>
                  <div>
                    <p className="text-sm font-semibold text-foreground-950">{point.title}</p>
                    <p className="mt-1 text-xs leading-relaxed text-foreground-600 md:text-sm">{point.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* 数据条 */}
            <div className="mt-6 grid gap-px overflow-hidden rounded-lg border border-background-200 bg-background-200 sm:grid-cols-3">
              {trustStats.map((stat) => (
                <div key={stat.label} className="bg-background-50 p-4 text-center md:p-5">
                  <p className="font-display text-2xl font-bold text-primary-500 md:text-3xl">{stat.value}</p>
                  <p className="mt-1.5 text-xs leading-relaxed text-foreground-600 md:text-sm">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}